import { useEditTournament } from "./useEditTournament";
import { useTournamentTab } from "./useTournamentTab";

export const useTournament = () => {
  const editTournament = useEditTournament();
  const tabs = useTournamentTab();

  return {
    ...editTournament,
    ...tabs,
  };
};
